import defaultTheme from "../defaultTheme"
import paywellTheme from "../paywellTheme"
import flexproTheme from "../flexproTheme"

const themeSelector = (companyName: string) => {
  switch (companyName) {
    case "paywell":
      return paywellTheme
    case "flexpro":
      return flexproTheme
    default:
      return defaultTheme
  }
}

export default themeSelector
